export const queryParamsToString = <T extends Record<keyof T, T[keyof T]>>(data: T) => {
    return Object.keys(data).map(item => {
        return `${item}=${data[item as keyof typeof data]}`
    }).join("&");
}